import { render, staticRenderFns } from "./gtr-survey-question.vue?vue&type=template&id=7d8838c5"
import script from "./gtr-survey-question.ts?vue&type=script&lang=ts&external"
export * from "./gtr-survey-question.ts?vue&type=script&lang=ts&external"
import style0 from "./gtr-survey-question.vue?vue&type=style&index=0&id=7d8838c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports